import React from 'react';
import '../../css/Styles.css';
import Spinner from '../../assets/Spinner.gif';

export default () => {
    return (
        <div className="background">
            <img src={Spinner} alt="로딩중" width="8%"></img>
        </div>
    );
};